exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading-with-text[data-v-322c6408]{position:relative}.loading-with-text p[data-v-322c6408]{margin-top:-70px}", ""]);

// exports
